module.exports = __webpack_public_path__ + "img/leopard-tech-labs-logo.859f235f.png";